import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function CommuteIcon(props: IconProps) {
    return <Icon {...props} iconKey={"commute"}/>
}
